/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    window.addEventListener('load', function () {
        var fancybox = document.querySelectorAll('a.fancybox, a[data-fancybox-group]');
        if (fancybox.length) {
            MoyaLoader.all([
                'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
                'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
            ]).then(function () {
                Fancybox.bind("a.fancybox, a[data-fancybox-group", {
                    groupAll: true,
                    Thumbs: {
                        autoStart: false,
                    },
                });
            });
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
